<header class="header" [class.open]="open" (click)="open = !open">
  <h3>{{header}}</h3>
  <img class="icon" src="../../assets/images/dropdown-white-{{open ? 'open' : 'closed'}}.svg" alt="">
</header>
<div class="body" [class.open]="open">
  <ng-content></ng-content>
</div>

